module.exports = __webpack_public_path__ + "media/customizations/blackwoodgroves/back-43942c676e5b49323ffaa8bf8a4aecd8.jpg";